export default __webpack_public_path__ + "static/media/tournament_banner.fde0e947.png";